document.addEventListener('readystatechange', function(event) {
    if (event.target.readyState === "complete") {
    const consentFooter = document.getElementById('custom-consent-footer');
    const overlay = document.getElementById('custom-consent-overlay');
    const consentPopup = document.getElementById('custom-consent-popup');
    const openConsentButton = document.getElementById('custom-openConsentPopup');
    const saveConsentButton = document.getElementById('custom-consent-save-consent');
    const closePopupButton = document.getElementById('custom-consent-close-consent-popup');
    const closeFooterButton = document.getElementById('custom-closeFooterPopup');
    const cookieSettingsAnchors = document.querySelectorAll('a[href="#cookie-settings"]');
  
    window.Shopify.loadFeatures(
     [
       {
         name: 'consent-tracking-api',
         version: '0.1',
       },
     ],
     error => {
       if (error) {
         console.log('we can no use consent settings from shopify');
       } else {
          console.log(window.Shopify.customerPrivacy)
           document.getElementById("custom-consent-marketing-allowed").checked = window.Shopify.customerPrivacy.marketingAllowed();
           document.getElementById("custom-consent-analytics-allowed").checked = window.Shopify.customerPrivacy.analyticsProcessingAllowed();
           document.getElementById("custom-consent-preferences-allowed").checked =window.Shopify.customerPrivacy.preferencesProcessingAllowed();
           if(localStorage.getItem("privacy-concent") === null) {
             consentFooter.style.display = 'flex';
           }
       }
     },
    );
  
    if (openConsentButton && consentPopup) {
  
      openConsentButton.addEventListener('click', function() {
        consentPopup.style.display = 'block';
        overlay.style.display = 'block';
      });
  
      cookieSettingsAnchors.forEach(function(el){
        el.addEventListener('click', function(e) {
          e.preventDefault();
          consentPopup.style.display = 'block';
          overlay.style.display = 'block';
        });
      })
  
    }
  
    if (saveConsentButton) {
      closeFooterButton.addEventListener('click', function(){
        save_consent();
      })
      closePopupButton.addEventListener('click', function(){
        consentPopup.style.display = 'none';
        overlay.style.display = 'none';
      })
      saveConsentButton.addEventListener('click', function() {
        save_consent();
      });
    }
    function save_consent() {
      const consentOptions = {
        marketing: document.getElementById("custom-consent-marketing-allowed").checked,
        analytics: document.getElementById("custom-consent-analytics-allowed").checked,
        preferences: document.getElementById("custom-consent-preferences-allowed").checked
      };
      window.Shopify.customerPrivacy.setTrackingConsent(
        consentOptions,
        () => {
          consentPopup.style.display = 'none';
          overlay.style.display = 'none';
          consentFooter.style.display = 'none';
          localStorage.setItem("privacy-concent", "true");
        }
      );
    }
    }
  });
  